var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeadRespond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#A44EF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438 27.769C29.6024 27.769 29.3744 27.6355 29.2599 27.4122C29.2448 27.3831 27.7165 24.503 23.7164 23.1418C22.0346 22.5692 20.4648 22.4265 19.3953 22.4137L19.3866 25.2733C19.3859 25.5182 19.2489 25.7422 19.0312 25.8546C18.8137 25.9668 18.5517 25.9486 18.3517 25.8075L9.77779 19.7529C9.60536 19.6312 9.502 19.4341 9.50003 19.2232C9.49806 19.0122 9.59765 18.813 9.76761 18.6882L18.3783 12.3586C18.5781 12.212 18.843 12.1901 19.064 12.3024C19.2849 12.4146 19.4238 12.6415 19.4232 12.8892L19.4155 15.7354C21.112 15.8277 24.2304 16.3514 26.7618 18.7577C30.0275 21.8624 30.48 26.8473 30.4977 27.058C30.5238 27.3705 30.3251 27.6581 30.0232 27.7441C29.9637 27.761 29.9033 27.769 29.8438 27.769ZM19.2314 21.1002C20.3997 21.1002 22.1993 21.239 24.1395 21.8992C26.1824 22.5945 27.6481 23.6351 28.6477 24.5804C28.1849 23.0437 27.3472 21.125 25.8577 19.7089C23.3142 17.2913 20.0688 17.0303 18.7914 17.0303H18.7574C18.5835 17.0303 18.4166 16.9612 18.2936 16.8383C18.1701 16.7148 18.1007 16.5471 18.1012 16.3724L18.1072 14.1869L11.2788 19.2063L18.078 24.0074L18.0849 21.764C18.0859 21.4124 18.3638 21.1241 18.7151 21.1102C18.857 21.1045 19.0306 21.1002 19.2314 21.1002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadRespond);
export default __webpack_public_path__ + "static/media/lead_respond.cbfab3d1e57c3edee8f001f522492927.svg";
export { ForwardRef as ReactComponent };